import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Crumb } from './crumb';

@Component({
    selector: 'giq-bread-crumbs',
    templateUrl: 'bread-crumbs.component.html',
    styleUrls: ['bread-crumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class BreadCrumbsComponent {
    @Input() crumbs: Crumb[] = [];
    constructor() { }
}